import { useBreadcrumb } from '@/hooks/useBreadcrumb'
import { useMobileHeader } from '@/hooks/useMobileHeader'
import { Container } from '@/features/global/components/Layout/Container'
import { H1 } from '@/components/label/H1'
import { FormInput } from '@/components/input/FormInput'
import { SubmitButton } from '@/components/button/SubmitButton'
import { useState } from 'react'
import { postForgotpwd } from '@/api/user'
import { validate as validateForgotpwd } from '@/validations/forgotpwd.validator'
import { useRouter } from 'next/router'

interface Props {
  email: string
}

export const ForgotpwdPage: React.FC<Props> = ({ email }) => {
  useMobileHeader(false)
  useBreadcrumb([
    {
      name: 'パスワードを忘れた',
    },
  ])
  const [inputValue, setInputValue] = useState(email)
  const [disabled, setDisabled] = useState(email === '')
  const [error, setError] = useState(false)
  const router = useRouter()

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value)
    const isValid = validateForgotpwd({ email: e.target.value })
    setDisabled(!isValid)
  }

  const onSubmit = async () => {
    setError(false)
    setDisabled(true)
    const res = await postForgotpwd(inputValue)
    if (!res.result) {
      setError(true)
      setDisabled(false)
      return
    }
    router.push('/user/forgotpwd_sent')
  }

  return (
    <Container sidebar={{ pc: false, sp: false }}>
      <div className="p-4 pb-12 w-full">
        <div className="pt-5 sm:pt-6 pb-6 text-center">
          <H1 title="パスワードを忘れた" />
          <div className="my-10">
            会員登録されているメールアドレスを入力してください。
            <br />
            パスワードの再設定方法を記載したメールをお送りしますので、そちらにしたがって処理を行ってください。
          </div>
          <div className="my-0 mx-auto w-full sm:w-[720px]">
            <FormInput
              caption="メールアドレス"
              type="email"
              name="email"
              require={true}
              value={inputValue}
              placeholder="メールアドレス"
              autoComplete="off"
              onChange={onInputChange}
            />
            {error && (
              <p className="text-red-500">
                パスワード再設定メールの送信に失敗しました。
                <br />
                しばらくしてからもう一度送信ボタンをクリックしてください。
              </p>
            )}
            <div className="my-10">
              <SubmitButton
                text="パスワード再設定メールを送信する"
                showArrow={true}
                disabled={disabled}
                onClick={onSubmit}
              />
            </div>
          </div>
          <div>
            ＊gmail / Yahoo!メール
            などのフリーメールアドレスでご登録の場合、迷惑フォルダに届く場合がございます。
            <br />
            ＊お問い合わせいただく前に、「迷惑メールフォルダ」を一度ご確認ください。
          </div>
        </div>
      </div>
    </Container>
  )
}
